module.exports = __webpack_public_path__ + "assets/b3d225cb2399c4fcd0d4a65f1a196ae9.png";